/*
 * @Author: wuhao
 * @Date: 2020-04-08 14:28:17
 * @LastEditors: wuhao
 * @LastEditTime: 2021-01-15 15:02:45
 * @Description: 封装table搜索条件
 */

import ApexTipButton from './src/index'

ApexTipButton.install = function(Vue) {
  Vue.component(ApexTipButton.name, ApexTipButton)
}

export default ApexTipButton
